import { environment } from 'src/environments/environment'
import { Observable, of } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output
} from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'
import { configurationOptionSelectors } from '../../configuration-option.selectors'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { UntilDestroy } from '@ngneat/until-destroy'
import {
  catchError,
  distinctUntilChanged,
  map,
  take,
  timeout
} from 'rxjs/operators'
import { ConfigurationOptionService } from '../../configuration-option.service'
import { Actions, ofType } from '@ngrx/effects'
import { configurationOptionActions } from '../../configuration-option.actions'
import { NotificationService } from 'src/app/core/notification.service'
import moment from 'moment-mini'

@UntilDestroy()
@Component({
  selector: 'configuration-option-my-work-card',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionMyWorkCardComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<any>()
  public formValues$: Observable<any>
  public isLoading$: Observable<boolean>
  public isCollapsed = false
  public accessRights = AccessRights

  public form: UntypedFormGroup
  public attachDocumentsToInvoiceForm: UntypedFormGroup
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return ((acc[curr] = true), acc)
      else return acc
    },
    {}
  )

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private cdref: ChangeDetectorRef,
    private configOptionService: ConfigurationOptionService,
    private actions$: Actions,
    private notificationService: NotificationService
  ) {}

  config: any = {
    placeholder: '',
    tabsize: 2,
    height: '200px',
    dialogsInBody: true,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear'
        ]
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']]
    ],
    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
      'opensans',
      'sansserif',
      'monospace',
      'serif'
    ]
  }
  ngOnInit() {
    this.form = this.fb.group({
      employee_calendar_days_ahead_available: ['', []],
      employee_calendar_max_date_available: ['', []],
      nl_employees_calendar_text: [],
      en_employees_calendar_text: [],
      fr_employees_calendar_text: [],
      de_employees_calendar_text: []
    })

    this.attachDocumentsToInvoiceForm = this.fb.group({
      isVisible: [null, []],
      isRequired: [null, []]
    })
    this.formValues$ = this.store
      .select(configurationOptionSelectors.selectAll)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        map((configOptions) =>
          this.configOptionService.mapEntitiesToObject(configOptions)
        )
      )

    this.formValues$.pipe(take(1)).subscribe((formValues) => {
      if (formValues?.employee_calendar_max_date_available) {
        setTimeout(() => {
          this.form.controls.employee_calendar_max_date_available.patchValue(
            formValues?.employee_calendar_max_date_available
          )
        }, 500)
      }

      if (formValues?.attach_documents_to_invoice) {
        const { isVisible, isRequired } = JSON.parse(
          formValues?.attach_documents_to_invoice
        )

        this.attachDocumentsToInvoiceForm.controls.isVisible.patchValue(
          isVisible
        )
        this.attachDocumentsToInvoiceForm.controls.isRequired.patchValue(
          isRequired
        )
      }
    })
    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )
  }

  public onFormSubmit(): void {
    if (!this.form.valid) {
      return
    }

    const employeeCalendarMaxDateAvailable = moment(
      this.form.controls.employee_calendar_max_date_available.value
    )
      .endOf('day')
      .toISOString()

    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(1000),
        catchError(() => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )

    this.configOptionService.updateOrCreateMany({
      ...this.form.value,
      employee_calendar_max_date_available: employeeCalendarMaxDateAvailable,
      attach_documents_to_invoice: JSON.stringify({
        isVisible: this.attachDocumentsToInvoiceForm.value.isVisible,
        isRequired: this.attachDocumentsToInvoiceForm.value.isRequired
      })
    })
  }
}
